<template>
  <div id="login">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col col-md-12 col-lg-10 col-xl-8">
          <div class="page-header" style="text-align: center;">
            <h1>Please sign in or register</h1>
          </div>
        </div>
      </div>
    </div>
    <div id="content">
      <div class="container">
        <div class="row justify-content-md-center align-items-center">
          <div class="col col-md-6 col-xl-5">
            <ul class="nav nav-tabs tab-lg" role="tablist">
              <li role="presentation" class="nav-item">
                <a class="nav-link" href="javascript:;"  v-bind:class="{ active: sigInTabToggle }"
                   v-on:click="sigInTabToggle = true ; $validator.reset();">
                  Sign In
                </a>
              </li>
              <li role="presentation" class="nav-item">
                <a class="nav-link" href="javascript:;" v-bind:class="{ active: !sigInTabToggle }"
                   v-on:click="sigInTabToggle = false ; $validator.reset();">
                  Register
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane" v-bind:class="{ active: sigInTabToggle }">
                <SignIn />
              </div>

              <div role="tabpanel" class="tab-pane" v-bind:class="{ active: !sigInTabToggle }">
                <Registration />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignIn from './login/SignIn.vue'
import Registration from './login/Registration.vue'

export default {
  name: 'login',
  components: {
    SignIn,
    Registration
  },
  data: function () {
    return {
      sigInTabToggle: true
    }
  },
  created: function () {
    if (this.$localStorage.get('apikey')) {
      this.$router.push('/')
    }
  }
}
</script>
